import React from 'react';
import { useTranslations, useLocale } from 'next-intl';

import Form from '../../molecules/form/form';
import pressGerman from './data/01-press';
import pressEnglish from './data/02-press-en';

const pressData = {
  de: pressGerman,
  en: pressEnglish
};

const PressForm = () => {
  const t = useTranslations();
  const locale = useLocale();
  return <Form {...pressData[locale]} withCsrfToken successMessage={t('form.pressSuccess')} />;
};

export default PressForm;
